// "Extractors" are what we've decided to call functions that convert GraphQL
// data to the types that the frontend code uses internally. The naming
// convention is `extract<TypeName>()`. Test Prep uses a similar naming
// convention for this.

import type {ProgramSimple} from "#scratchpad-shared-package/types.ts";

import type {projectsAuthoredByUser_user_programs_programs as GqlProgramType} from "../project-list-fetchers/__graphql-types__/projectsAuthoredByUser.ts";

export const extractProgram = (program: GqlProgramType): ProgramSimple => {
    const {
        __typename: _,
        id: __,
        imagePath,
        sumVotesIncremented,
        authorNickname,
        displayableSpinoffCount,
        url,
        ...filteredProgram
    } = program;

    return {
        authorNickname: authorNickname || "",
        sumVotesIncremented: sumVotesIncremented || 0,
        spinoffCount: displayableSpinoffCount || 0,
        thumb: imagePath || "",
        url: url || "",
        ...filteredProgram,
    };
};
